const AffirmLogo = () => {
  return (
    <svg
      width="80"
      height="38"
      viewBox="0 0 91 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.4583 21.3049C5.00119 21.3049 2.15269 22.4791 0.608841 23.6968L2.02222 26.654C3.26165 25.5233 5.26213 24.5666 7.06691 24.5666C8.78471 24.5666 9.71971 25.1319 9.71971 26.2844C9.71971 27.0672 9.08913 27.4586 7.91493 27.6108C3.47909 28.1761 0 29.3938 0 32.8077C0 35.504 1.93524 37.1565 4.93596 37.1565C7.08865 37.1565 9.00215 35.9606 9.91541 34.395V36.7217H13.9164V26.9585C13.9164 22.9358 11.1113 21.3049 7.4583 21.3049ZM5.95794 34.0254C4.82724 34.0254 4.26189 33.4818 4.26189 32.5685C4.26189 30.8724 6.15364 30.3071 9.61099 29.9374C9.63274 32.1988 8.08889 34.0254 5.95794 34.0254Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.6426 24.2622V21.7398H47.6416V36.7217H51.9252V29.5025C51.9252 26.0669 53.9909 25.0667 55.4478 25.0667C56.0132 25.0667 56.7742 25.2407 57.2743 25.6103L58.0571 21.6528C57.4048 21.3702 56.709 21.3049 56.1436 21.3049C53.9475 21.3049 52.5558 22.2834 51.6426 24.2622Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.9312 21.3049C75.6698 21.3049 73.9737 22.6531 73.0822 23.936C72.2559 22.2617 70.5381 21.3049 68.4507 21.3049C66.1892 21.3049 64.6237 22.5661 63.8844 24.0012V21.7398H59.7529V36.7217H64.0366V29.0024C64.0366 26.2409 65.4934 24.9145 66.8416 24.9145C68.0593 24.9145 69.19 25.6973 69.19 27.7413V36.7217H73.4953V29.0024C73.4953 26.1974 74.9087 24.9145 76.3221 24.9145C77.4528 24.9145 78.6488 25.7408 78.6488 27.7195V36.7217H82.9324V26.3714C82.9324 23.001 80.671 21.3049 77.9312 21.3049Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.0502 20.6308V21.7398H22.5486V20.2177C22.5486 18.239 23.6793 17.6736 24.6578 17.6736C25.2232 17.6736 25.9625 17.8041 26.5713 18.152L27.8977 15.1295C27.1149 14.6729 25.832 14.2597 24.1142 14.2597C21.3744 14.2597 18.265 15.8036 18.265 20.6526V21.7615H15.7861V25.0667H18.265V36.7216H22.5486V25.0449H29.0502V36.7216H33.3338V25.0449H37.226V21.7398H33.3338V20.2177C33.3338 18.239 34.4645 17.6736 35.443 17.6736C36.5302 17.6736 37.3565 18.152 37.3565 18.152L38.6829 15.1295C38.6829 15.1295 37.3348 14.2597 34.8994 14.2597C32.1814 14.238 29.0502 15.7818 29.0502 20.6308Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.7705 21.7397H44.0541V36.7216H39.7705V21.7397Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.7329 0.843506C53.1649 0.843506 42.8581 8.86716 39.9443 19.1957H44.141C46.5764 11.4982 54.8609 4.75748 64.7329 4.75748C76.7357 4.75748 87.086 13.8901 87.086 28.1109C87.086 31.3073 86.6729 34.1775 85.8901 36.7216H89.9563L89.9998 36.5912C90.6738 33.9601 91 31.1116 91 28.1109C91 12.2593 79.4538 0.843506 64.7329 0.843506Z"
        fill="#4850EB"
      />
    </svg>
  );
};

export default AffirmLogo;
